export const getLiveDailyReportChartData = (report) => {
  const hours = report.hours || [];
  const zones = report.zones || [];
  return Array.from({ length: 24 }, (_, hour) => {
    const metadata = hours.find((item) => item.hour === hour);
    const zoneHours = zones.map((zone) => zone.hours?.find((entry) => entry.hour === hour));
    const future = zoneHours.length > 0 && zoneHours.every((item) => item?.status === 'future');
    return {
      hour, label: `${String(hour).padStart(2, '0')}:00`, future,
      partial: metadata?.status === 'in_progress',
      values: zoneHours.map((item) => {
        const average = item?.status !== 'future' && item?.status !== 'not_active' && item?.covered_seconds > 0
          && Number.isFinite(item?.average_people_count) && item.average_people_count >= 0
          ? item.average_people_count : null;
        return {
          average,
          // Exactly half rounds down, matching the screenshot's display rule.
          people: average === null ? null : average > 0 ? Math.max(1, Math.ceil(average - 0.5)) : 0,
          coveredSeconds: item?.covered_seconds || 0,
          coverage: item?.coverage_percent,
        };
      }),
    };
  });
};
